import { inject, injectable } from 'inversify'
import 'reflect-metadata'
import { TYPES } from '../../../../common/domain/types'

import type { IDataSourceLookUpRepository } from '../domain/IDataSourceLookUpRepository';

import { IServiceDataSourceLookUp } from './IServiceDataSourceLookUp';
import { IapDataSourceLookUp } from '../domain/iapDataSourceLookUp';





@injectable()
export class DataSourceLookUpService implements IServiceDataSourceLookUp {
  private readonly repo: IDataSourceLookUpRepository

  public constructor (@inject(TYPES.DATASOURCELOOKUP_REPOSITORY) _repo: IDataSourceLookUpRepository) {
    this.repo = _repo
  }
    
  async update (data: IapDataSourceLookUp): (Promise<IapDataSourceLookUp>) {
    return await this.repo.update(data);
  }

  async delete (dataSourceId: number): (Promise<boolean>) {
    return await this.repo.delete(dataSourceId);
  }


  async add (data: IapDataSourceLookUp): (Promise<IapDataSourceLookUp>) {
    return await this.repo.add(data);
  }

  async getById(DataSourceLookUpId: number) :Promise<IapDataSourceLookUp> {
    return await this.repo.getById(DataSourceLookUpId)
  }


}